import { DocumentData, DocumentSnapshot, QueryDocumentSnapshot } from 'firebase/firestore';

export const buildObjectsTree = <T extends DocWithId>(
  docs: QueryDocumentSnapshot<DocumentData>[]
): Record<string, T> => {
  const objects: Record<string, T> = {};

  if (!docs || !docs.length) return objects;

  docs.forEach((doc) => (objects[doc.id] = buildObject(doc)));
  return objects;
};

export const buildObject = <T extends DocWithId>(doc: DocumentSnapshot<DocumentData>): T => {
  return (doc ? { id: doc.id, ...doc.data() } : {}) as T;
};

export type DocWithId = {
  id?: string;
} & DocumentData;
